// Sprint CAL-1b — «Storico» dell'attività (chiuso all'inizio, dal più recente), letto dal registro attività
import React, { useState } from "react";
import { api } from "@/lib/api";
import { fmtDataOra } from "@/pages/crm/crmComuni";

const quando = (iso) => (iso ? fmtDataOra(iso) : "senza scadenza");
export function dettaglioStorico(v) {
  if ("da" in v) return `${quando(v.da)} → ${quando(v.a)}`;
  if (v.nota && v.action === "calendario_evento.fatto") return v.nota;
  if (v.campi?.length) return v.campi.join(", ");
  return "";
}

export function StoricoAttivita({ id }) {
  const [aperto, setAperto] = useState(false);
  const [voci, setVoci] = useState(null);
  const cambia = () => {
    if (!aperto && !voci) api.get(`/calendario/eventi/${id}/storico`).then((r) => setVoci(r.data || [])).catch(() => setVoci([]));
    setAperto(!aperto);
  };
  return (
    <div className="border-t pt-2" data-testid="cal-storico">
      <button type="button" onClick={cambia} aria-expanded={aperto} className="text-sm font-medium text-slate-700 flex items-center gap-1"
        data-testid="cal-storico-apri">Storico <span aria-hidden>{aperto ? "▴" : "▾"}</span></button>
      {aperto && <div className="mt-1 max-h-48 overflow-y-auto space-y-1" data-testid="cal-storico-voci">
        {voci && !voci.length && <div className="text-xs text-slate-400">Nessuna voce</div>}
        {(voci || []).map((v, i) => (
          <div key={i} className="text-xs" data-testid={`cal-storico-voce-${i}`}>
            <span className="text-slate-500">{fmtDataOra(v.timestamp)} · {v.autore}</span> · <b>{v.cosa}</b>
            {dettaglioStorico(v) && <span className="text-slate-700">: {dettaglioStorico(v)}</span>}
          </div>))}
      </div>}
    </div>
  );
}
